export const DELETE_COMMENT_ACTION_BASE = "DELETE_COMMENT";
export const EDIT_COMMENT_ACTION_BASE = "EDIT_COMMENT";
export const CREATE_COMMENT_ACTION_BASE = "CREATE_COMMENT";

////////////////// CREATE COMMENT \\\\\\\\\\\\\\\\\\\\\\\\
export const createComment = (postId, commentContent) => ({
  type: `${CREATE_COMMENT_ACTION_BASE}_REQUEST`,
  postId,
  content: commentContent,
});

export const createCommentOptimistic = (postId, commentObject) => ({
  type: `${CREATE_COMMENT_ACTION_BASE}_OPTIMISTIC`,
  comment: commentObject,
  postId,
});

export const createCommentSuccess = (postId, pendingCommentId, newCommentObject) => ({
  type: `${CREATE_COMMENT_ACTION_BASE}_SUCCESS`,
  pendingCommentId,
  newComment: newCommentObject,
  postId,
});

export const createCommentFailed = (postId, pendingCommentId) => ({
  type: `${CREATE_COMMENT_ACTION_BASE}_FAILED`,
  pendingCommentId,
  postId,
});

////////////////// EDIT COMMENT \\\\\\\\\\\\\\\\\\\\\\\\
export const enterEditMode = ({ postId, commentId, isEditMode }) => {
  return {
    type: `SET_EDIT_COMMENT_MODE`,
    postId,
    commentId,
    isEditMode,
  };
};
export const editComment = ({ postId, commentId, content }) => {
  return {
    type: `${EDIT_COMMENT_ACTION_BASE}_REQUEST`,
    postId,
    commentId,
    content,
    meta: {
      mixpanel: {
        event: "comment.edit",
      },
    },
  };
};

export const editCommentOptimistic = ({ postId, commentId, content }) => {
  return {
    type: `${EDIT_COMMENT_ACTION_BASE}_OPTIMISTIC`,
    postId,
    commentId,
    content,
  };
};

export const editCommentFailed = ({ postId, commentId }) => {
  return {
    type: `${EDIT_COMMENT_ACTION_BASE}_FAILED`,
    postId,
    commentId,
  };
};

////////////////// DELETE COMMENT \\\\\\\\\\\\\\\\\\\\\\\\

export const deleteComment = ({ postId, commentId }) => {
  return {
    type: `${DELETE_COMMENT_ACTION_BASE}_REQUEST`,
    postId,
    commentId,
    meta: {
      mixpanel: {
        event: "comment.delete",
      },
    },
  };
};

export const deleteCommentOptimistic = ({ postId, commentId }) => {
  return {
    type: `${DELETE_COMMENT_ACTION_BASE}_OPTIMISTIC`,
    postId,
    commentId,
  };
};

export const deleteCommentFailed = ({ error, commentId }) => {
  return {
    type: `${DELETE_COMMENT_ACTION_BASE}_FAILED`,
    commentId,
    error,
  };
};



// WEBPACK FOOTER //
// ./src/actions/commentActions.js